import { createSharedSlice } from '@luna/state';

import { useRequestsCounterOptions } from './useRequestsCounterOptions';
import type { ObservePerformance } from '../observePerformance';
import { requestsObserverDevTool } from './requestsObserverDevTool';

export const useInitializedRequestsObserver = createSharedSlice({
    initialState: {
        observer: undefined as undefined | ObservePerformance,
    },
    reducers: {
        initializeRequestsObserver: (state) => {
            if (state.observer) {
                state.observer.disconnect();
            }

            state.observer = requestsObserverDevTool();
        },
        disconnectRequestsObserver: (state) => {
            if (!state.observer) {
                return;
            }

            state.observer.disconnect();
            state.observer = undefined;
        },
    },
});

/**
 * Exists so that we can initialize the observer at the beginning of the app lifecycle
 * to start observing requests from the very first call.
 * @remark the observer will only be initialized when intended by setting the 'request counter' in the
 * devtools, the observer therefore doesn't initialize in prod.
 * */
export const initRequestsObserver = (): void => {
    const { toggled } = useRequestsCounterOptions.getState();

    if (!toggled) {
        return;
    }

    useInitializedRequestsObserver.dispatchActions.initializeRequestsObserver();
};
